/// <reference path="/js/libs/wtcp.util.js" />
/// <reference path="/js/libs/wtcp.client.js" />
"use strict";

global.WtcpJs = global.WtcpJs || {};

var util = require('./wtcp.util.js');

(function(wtcp) {

    wtcp.WTCPAudio = function(client, settings) {

        const SMOOTHING = 0.8;
        const FFT_SIZE = 2048;

        var _this = this;
        var context;
        var gainNode;
        var visCanvas;
        var analyser;
        var micStream;
        var microphone, scriptNode, biquadFilter, offlineContext;
        var channelData;
        var sampleRate;
        var downsampleBuffer;
        var audioSamplesStarted = 0;
        var audioSamplesEnded = 0;
        var audioEndTime;
        var times;
        var initStatus = {
            status: 'inprogress',
            message: 'In Progress'
        };
        var micEnabled = false;
        var sendingAudio = false;
        var audioPlaying = false;
        var playerActive = settings.audioPlayerActive;
        var isVisualizing = false;
        var audioQueueTimeout = null;
        var audioQueue = [];
        var audioQueueBufferLength = 0;
        var endAudioSuccess, endAudioFailure;
        this.messageHandlers = {};

        this.getStatus = function getStatus() { return initStatus; }

        // Properties
        Object.defineProperty(this, "MicrophoneEnabled", { get: function() { return micEnabled; } });
        Object.defineProperty(this, "PlayerEnabled", {
            get: function() { return playerActive; },
            set: function (isEnabled) {
                playerActive = isEnabled;

                if (!(playerActive) && audioQueueTimeout) {
                    clearTimeout(audioQueueTimeout);
                    audioQueueTimeout = null;
                }

                util.wtcpDebug(`WtcpAudio.PlayerEnabled: audio player is now ${playerActive ? 'on' : 'off'}`);
            }
        });

        function asFloat(pct) {
            return pct < 0 ? 0 : pct >= 100 ? 1 : pct / 100;
        }

        /* remove this after some testing
        function convertToMono(input) {
            var splitter = context.createChannelSplitter(2);
            var merger = context.createChannelMerger(2);

            input.connect(splitter);
            splitter.connect(merger, 0, 0);
            splitter.connect(merger, 0, 1);
            return merger;
        } */

        function audioBufferSourceNodeEnded(e) {
            if (++audioSamplesEnded === audioSamplesStarted) {
                audioPlaying = false;
                audioSamplesEnded = 0;
                audioSamplesStarted = 0;
            }
        }

        function setGain(val) {
            gainNode.gain.value = asFloat(val);
        }

        function draw() {
            // Draw the time domain chart.
            var bufferLength = analyser.frequencyBinCount;
            var sliceWidth = visCanvas.width * 1.0 / bufferLength;
            var x = 0, v = 0, y = 0;
            var drawCtx = visCanvas.getContext('2d');
            drawCtx.clearRect(0, 0, visCanvas.width, visCanvas.height);
            drawCtx.lineWidth = 2;
            drawCtx.strokeStyle = 'white';
            drawCtx.beginPath();

            analyser.getByteTimeDomainData(times);

            for (var i = 0; i < bufferLength; i++) {
                v = times[i] / 128.0;
                y = v * visCanvas.height / 2;

                if (i === 0)
                    drawCtx.moveTo(x, y);
                else
                    drawCtx.lineTo(x, y);

                x += sliceWidth;
            }

            drawCtx.lineTo(visCanvas.width, visCanvas.height / 2);
            drawCtx.stroke();
        }

        function startAudio(src) {
            audioSamplesStarted++;

            src.connect(gainNode);
            gainNode.connect(isVisualizing ? analyser : context.destination);

            if (!audioPlaying) {
                audioPlaying = true;
                //audioEndTime = context.currentTime + .05;
                audioEndTime = context.currentTime;
            }
            src.start(audioEndTime);
            audioEndTime += (src.buffer.duration);

            if (isVisualizing)
                requestAnimationFrame(draw);
        }

        this.playAudio = function(buffer, audioLength) {
            if (!playerActive)
                return;

            audioQueue.push(buffer);
            audioQueueBufferLength += audioLength;

            if (!audioQueueTimeout) {
                audioQueueTimeout = setTimeout(function() {
                    var data = audioQueue;
                    var len = audioQueueBufferLength;

                    audioQueue = [];
                    audioQueueBufferLength = 0;

                    var src = context.createBufferSource();
                    src.onended = audioBufferSourceNodeEnded;

                    var b = data[0];
                    for (var x = 1; x < data.length; x++) {
                        b = util.mergeArrayBuffers({ buffer: b, offset: 0 }, { buffer: data[x], offset: 0 });
                    }

                    // Experimental feature - trying to decode Opus. Use if (1) to enable
                    if (0) {
                        context.decodeAudioData(buffer, function(data) {
                            src.buffer = data;

                            startAudio(src);
                        }, function(e) { util.wtcpInfo("Error decoding audio", e); });
                    } else {
                        var audioArrayBuffer = context.createBuffer(1, (len / 2), 8000);
                        audioArrayBuffer.copyToChannel(new Float32Array(b), 0);
                        src.buffer = audioArrayBuffer;

                        util.wtcpDebug("Scheduling audio clip: duration = " + src.buffer.duration + ", Queue depth: " + data.length + ", buffer length: " + len);
                        startAudio(src);

                        audioQueueTimeout = null;
                    }
                }, 250);
            }
        };

        this.sendAudio = function() {

            // scriptProcessorNode's dont work on OfflineAudioContexts in chrome. Its not getting fixed
            // because scriptprocessor nodes are going away in favor of Audio Workers, which will work with offlinecontexts
            // Will have to use scriptProcessorNode for now

            if (!sendingAudio && typeof context.createMediaStreamSource === "function") {
                let halting = false;
                sendingAudio = true;

                if (micStream) {

                    microphone = context.createMediaStreamSource(micStream);
                    scriptNode = context.createScriptProcessor(settings.processorNodeBufferSize, 1, 1);
                    biquadFilter = context.createBiquadFilter();
                    biquadFilter.type = 'lowpass';
                    biquadFilter.frequency.value = 4000;
                    biquadFilter.Q.value = 2;

                    scriptNode.onaudioprocess = function(e) {

                        /* ---------------- OfflineAudioContext method of downsampling audio ---------------------------------------- 
                        // This works but you still get clicking artifacts after every sample
                        var b, source;
                        offlineContext = new OfflineAudioContext(1, e.inputBuffer.length / (e.inputBuffer.sampleRate / 8000), 8000);

                        offlineContext.oncomplete = function(audioBuffer) {
                            var buffer = audioBuffer.renderedBuffer.getChannelData(0).buffer;
                                client.SendMessage("processAudio", 1, {
                                    sampleRate: 8000,
                                    channelData: buffer
                                }, [buffer]);
                        };

                        downsampleBuffer = offlineContext.createBuffer(1, e.inputBuffer.length, e.inputBuffer.sampleRate);

                        b = downsampleBuffer.getChannelData(0);
                        e.inputBuffer.copyFromChannel(b, 0);

                        source = offlineContext.createBufferSource();
                        source.buffer = downsampleBuffer;
                        source.connect(offlineContext.destination);
                        source.start(0);

                        offlineContext.startRendering();

                        /* ------------------------------------------------------------------------------------------------------------*/

                        /* ----------------- Pass audio buffer straight to worker thread where it can be manually down-sampled  ------- */

                        sampleRate = e.inputBuffer.sampleRate;
                        channelData = new Float32Array(e.inputBuffer.length);
                        e.inputBuffer.copyFromChannel(channelData, 0);

                        client.SendMessage("processAudio", 1, {
                            sampleRate: sampleRate,
                            channelData: channelData.buffer,
                            flush: !sendingAudio
                        }, [channelData.buffer]);

                        if (!sendingAudio && !halting) {
                            try {
                                client.SendMessage("endAudio", 1);
                                halting = true;
                            } catch (err) {
                                endAudioFailure(err);
                            }
                        }
                        /* -------------------------------------------------------------------------------------------------------------*/
                    }

                    // Due to chrome autoplay policy from Chrome 71, we need to call resume (https://goo.gl/7K7WLu) 
                    context.resume();
                    microphone.connect(biquadFilter);
                    biquadFilter.connect(scriptNode);
                    scriptNode.connect(context.destination);
                }
            }
        };

        this.messageHandlers['audioEnded'] = function() {
            microphone.disconnect();
            biquadFilter.disconnect();
            scriptNode.disconnect();
            util.wtcpDebug('audio: audioEnded handled, disconnected microphone and script node');
            endAudioSuccess();
        };

        this.endAudio = function() {

            return new Promise(function(resolve, reject) {
                if (microphone) {
                    sendingAudio = false;
                    endAudioSuccess = resolve;
                    endAudioFailure = reject;
                } else {
                    resolve();
                }
            });
        };

        this.setVolume = function(val) {
            setGain(val);
        }

        this.visualize = (canvas) => {
            times = new Uint8Array(analyser.frequencyBinCount);
            visCanvas = canvas;
            isVisualizing = true;
        };

        var init = function() {
            util.setLoggingLevel(settings.loggingLevel);
            try {
                // Fix up for prefixing
                window.AudioContext = window.AudioContext || window.webkitAudioContext;
                window.OfflineAudioContext = window.OfflineAudioContext || window.webkitOfflineAudioContext;
                context = new AudioContext();
                gainNode = context.createGain();
                setGain(settings.initialVolume);
                analyser = context.createAnalyser();
                analyser.minDecibels = -140;
                analyser.maxDecibels = 0;
                analyser.smoothingTimeConstant = SMOOTHING;
                analyser.fftSize = FFT_SIZE;
                analyser.connect(context.destination);
            } catch (e) {
                throw "Initialization error: " + e.message;
            }

            try {
                if (navigator.mediaDevices === undefined) {
                    util.wtcpError("you are not secure running browser.");
                    throw "current DOM is not loaded securely. try to use https instead of http";
                }  
                if (navigator.mediaDevices.getUserMedia) {
                    navigator.mediaDevices.getUserMedia({ audio: true })
                        .then(function(stream) {
                            micStream = stream;
                            micEnabled = true;
                            initStatus = {status: 'ready', message: 'Ready'};
                        })
                        .catch(function(err) {
                            util.wtcpError("getUserMedia error", err);
                            initStatus = {status: 'error', message: err.message};
                        });
                } else {
                    navigator.getUserMedia = navigator.getUserMedia ||
                        navigator.webkitGetUserMedia ||
                        navigator.mozGetUserMedia ||
                        navigator.msGetUserMedia;

                        navigator.getUserMedia({ audio: true }, function (stream) {
                                micStream = stream;
                                micEnabled = true;
                                initStatus = { status: 'ready', message: 'Ready' };
                            }, function (err) {
                                util.wtcpError("getUserMedia error: " + err.message);
                                initStatus = { status: 'error', message: err.message };
                            });
                    } 
            } catch (e) {
                throw "getUserMedia() is not supported in your browser";
            }
        }

        init();
    };

    module.exports = wtcp;
})({});